import { setContext } from '@apollo/client/link/context';

import { getValidAccessToken } from '@/auth/refreshCoordinator';

/**
 * Attaches `Authorization: Bearer <token>` to every GraphQL request, reading from the module-level
 * token store (never a React hook — this runs outside the render tree,
 * docs/development/FrontendGuidelines.md §6.2 point 3). GraphQL resolvers never see a login attempt; by the
 * time a request reaches Willnq.GraphQL it already carries an authenticated `CurrentUser` via the
 * gateway (ADR-0010) — this link's only job is forwarding the bearer token that makes that true.
 */
export const authLink = setContext(async (_operation, { headers }) => {
  const token = await getValidAccessToken();
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});
